import React from "react";
import { Box, Link, Divider } from "@mui/material";

export default function Footer() {
    return (
        <>
            <Divider sx={{ mt: "auto" }} />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: { xs: 2, md: 4 },
                    py: 2,
                    fontSize: "0.85rem",
                    color: "#888",
                    letterSpacing: 1,
                }}
            >
                <Box>
                    <Link href="#" underline="hover" sx={{ mr: 3, color: "#888" }}>
                        PRIVACY POLICY
                    </Link>
                    <Link href="#" underline="hover" sx={{ color: "#888" }}>
                        TERMS OF USE
                    </Link>
                </Box>
                <Box>&copy;2025 Alcon Inc.</Box>
            </Box>
        </>
    );
}